import { http } from '@/services'

export const integrationCredentials = {
    async showCredentials(id: string | number) {
        const { data } = await http.get(`api/v1/integrations/show-credentials/${id}`)
        return data
    }
}
